import classnames from 'classnames';
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './styles.scss';

const LEVEL_COLORS = ['transparent', '#3e3754', '#414473', '#2d5669'];

class MenuItem extends Component {
  render() {
    const {
      caret,
      'data-aaa': dataAaa,
      iconClass,
      level = 0,
      menuKey,
      text,
      to,
      href,
      handleMenuItemClick,
      selectable = true,
    } = this.props;

    const backgroundColor = LEVEL_COLORS[level];
    const caretBackgroundColor = (() => {
      if (caret === 'up') {
        return LEVEL_COLORS[level + 1];
      }

      return backgroundColor;
    })();

    const caretEl = caret ? <i className={`fas fa-caret-${caret}`} /> : null;

    const outerClassName = classnames([styles.menuItem, selectable && styles.selectable]);

    const onClick = () => handleMenuItemClick({ menuKey, selectable });

    const inner = (
      <>
        <div key="menuItemContent" className={styles.menuItemContent}>
          {iconClass && <i className={iconClass} />}
          <span className={styles.menuItemText}>{text}</span>
        </div>
        <div
          key="menuItemCaret"
          className={styles.menuItemCaret}
          style={{ backgroundColor: caretBackgroundColor }}
        >
          {caretEl}
        </div>
      </>
    );

    if (href) {
      return (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={outerClassName}
          style={{ backgroundColor }}
        >
          {inner}
        </a>
      );
    }

    if (selectable) {
      return (
        <NavLink
          data-aaa={dataAaa}
          to={to}
          activeClassName={classnames(styles.selected, 'aaa-selected')}
          className={outerClassName}
          onClick={onClick}
          style={{ backgroundColor }}
        >
          {inner}
        </NavLink>
      );
    }

    return (
      <div
        data-aaa={dataAaa}
        className={outerClassName}
        onClick={onClick}
        style={{ backgroundColor }}
      >
        {inner}
      </div>
    );
  }
}

export default MenuItem;
